import createCache from '@emotion/cache'
import {prefixer} from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'

const runCreateCache = (isRtl: boolean) => {
  return createCache({
    // prefixer goes at the end
    stylisPlugins: isRtl ? [rtlPlugin, prefixer] : [prefixer],
    key: isRtl ? 'ec-rtl' : 'ec' //emotion-cache
  })
}

/**
 * Creates a cache for the emotion library
 * @deprecated Use the emotion cache provider instead
 * @param isRtl
 * @returns
 */
export const evaluateInRuntime = (isRtl: boolean) => {
  return runCreateCache(isRtl)
}
